import { OnDestroy, OnInit, Inject, Component, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { IPageData } from '../../../interfaces/page-data';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import * as PageActions from '../../../store/actions/page.actions';
import { Options } from 'ng5-slider';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { interval, Observable, Subject } from 'rxjs'
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Spinkit } from 'ng-http-loader'; // <============
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page';
import { TCModalService } from 'src/app/ui/services/modal/modal.service';
import { Content } from 'src/app/ui/interfaces/modal';
import { analyzeAndValidateNgModules, analyzeFile } from '@angular/compiler';
import { environment } from 'src/environments/environment';
import { retryWhen } from 'rxjs/operators';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';
import { TouchSequence } from 'selenium-webdriver';
import { FormGroup, FormControl, Validators, FormBuilder, NgForm } from '@angular/forms';
import { AngularStripeService } from "@fireflysemantics/angular-stripe-service";
import { MAT_DATE_FORMATS } from '@angular/material/core';



@Component({
  selector: 'order-menu-page',
  templateUrl: './order-menu.component.html',
  styleUrls: ['./order-menu.component.scss']
})
export class OrderMenuComponent extends BasePageComponent implements OnInit, OnDestroy {
  iconmenu = './assets/img/menu.svg';
  iconAtvmenu = './assets/img/greymenu.svg';

  iconcart = './assets/img/green_cart.svg';
  iconAtvcart = './assets/img/cart.svg';

  iconorder = './assets/img/green_orders.svg';
  iconAtvorder = './assets/img/order.svg';

  iconprofile = './assets/img/greenprofile.svg';
  iconAtvprofile = './assets/img/profile.svg';

  @ViewChild('cardInfo') cardInfo: ElementRef;
  details: any[] = [
    {
      "name": "Aubergine bhaji",
      "id": "1249",
      "price": "4.6",
      "Counter": "1"

    },
    {
      "name": "Basmati Rice",
      "id": "1286",
      "price": "2.7",
      "Counter": "1"
    },
  ];
  pageData: IPageData;
  value: number = 0;
  public spinkit = Spinkit;
  errorMessage
  restoID;
  name;
  toggle;
  allergenceArray = []
  diestPrefArray = []
  changeColorallergens = [];
  changeColordiet = []
  changeColors = []
  showmenus = '1'
  searchText
  allDietDatas
  allAllergDatas
  products: any
  totalcartvalue = 0;
  valueOrder
  conditionToDisaply = false
  orders = []
  dishes = [];
  dishesAlldata
  UserCondition
  token
  cartEmpty
  orderDishes
  orderId
  userName
  orderstatus
  orderIDvalue
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  userName_loggedin: string;
  user_Name: string[];
  strikeCheckout: any = null;
  payment_mood = 'Cod'
  show_guest_modal: boolean = false

  paymentForm: FormGroup;
  stripeCardValid: boolean = false;
  stripe;
  loading = false;
  confirmation;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;
  constructor(store: Store<IAppState>,
    public httpSv: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    private modal: TCModalService,
    private _location: Location,
    private stripeService: AngularStripeService,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,

  ) {
    //  ,private _Activatedroute:ActivatedRoute
    super(store, httpSv);

    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: "order-menu",
          route: 'order-menu'
        }
      ]
    };
  }
  results;
  allalergence;
  allDiet
  allergenceArrayName
  diestPrefArrays
  // spiceRatings =[]
  spiceRating
  tableids
  selectedAlleregence
  tableID
  orderItem = [];
  orderList = [];
  orderdata = [];
  spicevalue = [];
  onlineStatus;
  Guest_name
  restoName
  ngOnInit() {
    this.ids = sessionStorage.getItem('restoIds');
    this.tableids = sessionStorage.getItem('tableIds');
    this.tableID = sessionStorage.getItem('tableId');
    this.restoID = sessionStorage.getItem("restoId");
    this.spiceRating = sessionStorage.getItem("spiceRating")
    this.allergenceArrayName = sessionStorage.getItem("allergenceArrayName")
    this.diestPrefArrays = sessionStorage.getItem("diestPrefArrayName")
    this.restoID = sessionStorage.getItem("restoId")
    this.token = sessionStorage.getItem('access_token')
    this.selectedAlleregence = sessionStorage.getItem('allergenceArrayName')
    this.dishesAlldata = sessionStorage.getItem('orders-data')
    this.onlineStatus = sessionStorage.getItem('onlineStatus')
    const dataAlleregy = sessionStorage.getItem("selectedAlleregence")
    this.allAllergDatas = JSON.parse("[" + dataAlleregy + "]");
    const dataDiet = sessionStorage.getItem("selectedDiestpref");
    this.restoName = sessionStorage.getItem("restoName")
    this.allDietDatas = JSON.parse("[" + dataDiet + "]");
    const numberSpice = parseInt(this.spiceRating)
    for (let i = 0; i < numberSpice; i++) {
      this.spicevalue.push(i)
    }


    // this.httpSv.allAllergDataAll.subscribe((allPassedDataAll) => {
    //   this.allAllergDatas = allPassedDataAll;      
    //   sessionStorage.setItem("allAllergDatas",this.allAllergDatas)
    // })

    // this.httpSv.allDietDataAll.subscribe((allPassedDataAll) => {
    //   this.allDietDatas = allPassedDataAll;
    //     sessionStorage.setItem("allDietDatas",this.allDietDatas)
    // })

    this.results = this.allDietDatas.concat(this.allAllergDatas);;

    this.dishes = JSON.parse(this.dishesAlldata)
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    if (this.UserCondition) {
      this.userName_loggedin = sessionStorage.getItem('userName')
      // this.user_Name = this.userName_loggedin.split(" ");
      // this.userName = this.user_Name[0]
      this.paymentForm = this.fb.group({
        name: ['']
      });
      if (this.dishes && this.dishes.length > 0) {
        this.showmenuOrderget()
        this.getTotalPrice()
      } else {
        this.cartEmpty = "./assets/img/empty_cart.png"
        // this.cartEmpty = "./assets/img/Nobatske.png"
      }
    }
    else {
      if (this.dishes && this.dishes.length > 0) {
        // this.showmenuOrder()
        this.showmenuOrderget()
        this.getTotalPrice()
      } else {
        this.cartEmpty = "./assets/img/empty_cart.png"
      }

    }
    let ords = JSON.parse(sessionStorage.getItem('orders-data'));

    if (ords && ords.length) {
      this.conditionToDisaply = true;
      this.orders = ords;
    }
    let savedUserData = JSON.parse(sessionStorage.getItem('savedData'));
    if (savedUserData && savedUserData.length) {
      this.dishes = savedUserData;
    }
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0)
    // this.stripePaymentGateway();
    // this.Guest_name = sessionStorage.getItem('Guest_name')
    this.checkValue = sessionStorage.getItem("orders-data")
    this.lengths = JSON.parse(this.checkValue)
    if (this.lengths == null || this.lengths == 0) {
      this.hideTable = true;
    } else {
      this.checkLength = this.lengths.map((item: any) => {
        return item.indexVal
      })
      this.hideTable = false;
    }
    this.getTotalPrice()
    this.sub = interval(500)
      .subscribe((val) => {
        this.cartLength = sessionStorage.getItem('orders-data');
        this.length = JSON.parse(this.cartLength)
        this.counts = this.length?.map((item: any) => {
          return item.indexVal
        })
        this.lengths = this.counts?.length
      });
  }

  cartLength
  length
  counts
  sub
  lengths
  ngOnChanges(): void {
    if (this.cartLength) {
      this.sub = interval(500)
        .subscribe((val) => {
          this.cartLength = sessionStorage.getItem('orders-data');
          this.length = JSON.parse(this.cartLength)
          this.counts = this.length?.map((item: any) => {
            return item.indexVal
          })
          this.lengths = this.counts?.length
        });
    }
    else {
      this.counts = 0;
    }
  }
  myCartDetails() {
    this.httpSv.myCart().subscribe((res: any) => {
    })
  }

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.ref.detach();
    this.store.dispatch(new PageActions.Reset());
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.ref.detach();
      this.ref.detectChanges();
      this.ref.detach();
    }
  }
  allergenceArrayNumbers = []


  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], { queryParams: { id: this.ids, table_id: this.tableids } });
        }
        else {
          // this.resetFormLoad = false;
          Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  onClikOtp(): void {
    this._bottomSheet.open(BottomSheetGuestLogin, {
      disableClose: true
    });
  };

  backHomeUser() {
    this.router.navigate(['/horizontal/resto'])
  }
  backHomeGuest() {
    this.router.navigate(['/public/resto'])
  }

  goToMenu() {
    this.router.navigate(['/vertical/food-menu'])
  }

  onCheckboxChange

  values = 0;

  handleMinus() {
    this.values--;
  }
  handlePlus() {
    this.values++;
  }
  // get data
  // parameters:
  // * url - data url
  // * dataName - set data to 'dataName'
  // * callbackFnName run callback function with name 'callbackFnName'

  menuData = []
  ids;
  listfArray = []
  display_add_on = []
  showmenuOrder() {

    for (let i = 0; i < this.dishes.length; i++) {
      let temp =
      {
        food_dish_id: this.dishes[i].food_dish_id,
        quantity: this.dishes[i].quantity,
        spice_rating: this.dishes[i].spice_rating,
        option_id: this.dishes[i].option_id,
        rdaoop_id: this.dishes[i].rdaoop_id
      }

      this.orderItem.push(temp)
    }


    this.httpSv.showmenuOrder(this.restoID, this.orderItem).subscribe(
      response => {
        if (response['status'] == true) {
          this.menuData = response['result'].data
          this.listfArray.push(this.menuData)


          this.showmenus = '1'
        }
        else {
          // this.resetFormLoad = false;
          // Swal.fire("Something Went Wrong")
        }

      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
      }
    )


  }


  spiecvalue(j) {
    let spicevar = []
    for (let i = 0; i < j; i++) {
      spicevar.push(j)
    }
    return spicevar
  }
  backClicked() {
    if (this.UserCondition) {
      this.router.navigate(['/vertical/food-menu'])
    } else {
      this.router.navigate(['/public/food-menu-guest'])
    }

  }


  goToRegistration() {
    // this.router.navigate(['/public/sign-up']);
    Swal.fire({
      icon: 'error',

      title: 'Currently unavailable',
      confirmButtonText: `close`,

    })

  }


  totalprice
  FinalArray = []
  totalcartvalues = 0;
  dishAddons: any[] = []
  dishDetailsResponse
  checkAddon(index, items) {
    this.httpSv.getDishDetailsForAddon(this.restoID, items.food_dish_id).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.dishDetailsResponse = res['result'];
        this.dishAddons = res['result'].dish_addons;
        let data = {
          food_dish_id: items.food_dish_id,
          addonArray: this.dishDetailsResponse,
          index: index
        }
        let sheetRefs = this._bottomSheet.open(BottomSheetDishAddon, {
          data: data
        });

        sheetRefs.afterDismissed().subscribe((dataFromChild) => {
          this.orderItem = [];
          this.showmenuOrderget();
          this.getTotalPrice()
          this.lengths = dataFromChild.lengths;
          this.conditionToDisaply = true;
          this.getQuantity(dataFromChild.food_dish_id, dataFromChild.index)
          this.calculatePriceForAddon(dataFromChild.price)
        });
      }
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })

  }

  calculatePriceForAddon(price) {
    if (price.length) {
      for (let ords of price) {
        let somevalue = price.map(element => {
          return (element.addonPrice * element.addonQuantity)
        });
        this.totalPriceAddon = somevalue.reduce((a, b) => a + b, 0);
      }
      this.totalPriceAfterAddition = this.totalPriceAfterAddition + this.totalPriceAddon;
    }
  }
  editAddOns(items, index) {
    this.httpSv.getDishDetailsForAddon(this.restoID, items.food_dish_id).subscribe(res => {
      if (res['status'] == "TRUE") {
        this.dishDetailsResponse = res['result'];
        let variantReqIndex = this.dishDetailsResponse['dish_options'].findIndex((ele) => ele.option_name == items.option_name)

        this.dishAddons = res['result'].dish_addons;
        let data = {
          food_dish_id: items.food_dish_id,
          addonArray: this.dishDetailsResponse,
          index: index,
          variantReqIndex: variantReqIndex
        }
        let sheetRefs = this._bottomSheet.open(BottomSheetDishEditAddon, {
          data: data
        });

        sheetRefs.afterDismissed().subscribe(() => {
          // this.orderItem = [];
          // this.showmenuOrderget();
          // this.getTotalPrice()
          // this.lengths = dataFromChild.lengths;
          // this.conditionToDisaply = true;
          // this.getQuantity(dataFromChild.food_dish_id, dataFromChild.index)
          // this.calculatePriceForAddon(dataFromChild.price)
          this.getTotalPrice()
          this.showmenuOrderget()
        });
      }
    })

  }
  dish = []
  finalDishes: any[] = []
  someddddddata
  accArray = []
  valueOrders: any[] = [];
  ordersss = []
  foodDishId
  // code added to hide the duplicate values
  addToCart(indexValue, propductId, name, price, originalPrice) {
    let local = JSON.parse(sessionStorage.getItem('orders-data'))
    if (local[indexValue]['rdaoop_id']) {
      // this.httpSv.getDishDetailsForAddon(this.restoID, propductId).subscribe((res: any) => {
      //   if (res['status'] == "TRUE") {
      //     this.dishDetailsResponse = res['result'];
      //     this.dishAddons = res['result'].dish_addons;
      //     let data = {
      //       food_dish_id: propductId,
      //       addonArray: this.dishDetailsResponse,
      //       index: indexValue
      //     }
      //     let sheetRefs = this._bottomSheet.open(BottomSheetDishAddon, {
      //       data: data
      //     });

      //     sheetRefs.afterDismissed().subscribe((dataFromChild) => {

      //     }
      this.httpSv.getDishDetailsForAddon(this.restoID, propductId).subscribe(res => {
        this.dishDetailsResponse = res['result'];
        this.dishAddons = res['result'].dish_addons;
        let data = {
          food_dish_id: propductId,
          addonArray: this.dishDetailsResponse,
          index: indexValue
        }
        let sheetRefs = this._bottomSheet.open(BottomSheetDishAddon, {
          data: data
        });
        sheetRefs.afterDismissed().subscribe(() => {
          this.getTotalPrice()
          this.showmenuOrderget()
        })
      })


    }
    else {
      this.totalcartvalues += 1;
      let count = 1
      let push = true
      let ords = JSON.parse(sessionStorage.getItem('orders-data'));
      if (ords && ords.length) {
        this.orders = ords;
      }
      let value = this.orders[indexValue]
      this.accArray = []
      this.accArray.push(value);
      for (let ords of this.accArray) {
        if (ords.food_dish_id == propductId) {
          ords.quantity++;
          this.foodDishId = ords.food_dish_id;
          if (ords.rdaoop_id) {
            ords.rdaoop_id.map(element => {
              return element.addonQuantity++
            });
          }
          ords.Price = parseInt(ords.Price)
          ords.Price = ords.Price + parseInt(originalPrice)
          push = false
          this.conditionToDisaply = true
        }
      }

      if (push) {
        this.dish
        this.orders.push({ "indexVal": indexValue, "quantity": count, "food_dish_id": propductId, "Name": name, "Price": price, "originalPrice": originalPrice })
        this.FinalArray.push({ "indexVal": indexValue, "quantity": count, "food_dish_id": propductId, "Name": name, "Price": price, "originalPrice": originalPrice });
        sessionStorage.setItem('FianlArray', JSON.stringify(this.FinalArray));
        sessionStorage.setItem("count", JSON.stringify(this.orders));
        this.conditionToDisaply = true
      }
      else {
        sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
        sessionStorage.setItem("count", JSON.stringify(this.orders.length));
      }
      this.getQuantity(this.foodDishId, indexValue)
      this.conditionToDisaply = true
      this.getTotalPrice();
    }
  }

  // previous code commented by prakash just to hide the duplicate values
  // addToCart(indexValue, propductId, name, price, originalPrice) {
  //   //conditions to display +  and - buttons
  //   this.totalcartvalues += 1;
  //   let count = 1
  //   let push = true
  //   let ords = JSON.parse(sessionStorage.getItem('orders-data'));
  //   if (ords && ords.length) {
  //     this.orders = ords;
  //   }
  //   for (let ords of this.orders) {
  //     if (ords.food_dish_id == propductId) {
  //       ords.quantity++;
  //       if(ords.rdaoop_id) {
  //         ords.rdaoop_id.map(element => {
  //           return element.addonQuantity++
  //         });
  //       }
  //       ords.Price = parseInt(ords.Price)
  //       ords.Price = ords.Price + parseInt(originalPrice)
  //       push = false
  //       this.conditionToDisaply = true
  //     }
  //   }
  //   if (push) {
  //     this.dish
  //     this.orders.push({ "indexVal": indexValue, "quantity": count, "food_dish_id": propductId, "Name": name, "Price": price, "originalPrice": originalPrice })
  //     this.FinalArray.push({ "indexVal": indexValue, "quantity": count, "food_dish_id": propductId, "Name": name, "Price": price, "originalPrice": originalPrice });
  //     sessionStorage.setItem('FianlArray', JSON.stringify(this.FinalArray));
  //     sessionStorage.setItem("count", JSON.stringify(this.orders));
  //     this.conditionToDisaply = true
  //   }
  //   else {
  //     sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
  //     sessionStorage.setItem("count", JSON.stringify(this.orders.length));
  //   }
  //   this.getQuantity(propductId)
  //   this.conditionToDisaply = true
  //   this.getTotalPrice();
  // }

  getQuantity(dishId, index) {
    let ords = JSON.parse(sessionStorage.getItem('orders-data'));
    if (ords && ords.length) {
      this.orders = ords;
    }
    let value = this.orders[index]
    this.accArray = []
    this.accArray.push(value);

    for (let orderse of this.orders) {
      if (orderse.food_dish_id == dishId) {
        return orderse.quantity
      }
    }
  }

  addToCartDone(quantity, propductId) {
    if (quantity != 0) {
      const itemindex = this.dishes.findIndex(obj => obj["food_dish_id"] == propductId);
      if (itemindex > -1) {
        this.dishes[itemindex]["quantity"] = quantity
      }
      else {
        let one = { "quantity": quantity, "food_dish_id": propductId };
        this.dishes.push(one);
      }
    }
    else {
      const itemindex = this.dishes.findIndex(obj => obj["food_dish_id"] == propductId);
      if (itemindex > -1) {
        this.dishes.splice(itemindex, 1);
      }
    }
    sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
    sessionStorage.setItem("count", JSON.stringify(this.orders));
    this.getTotalPrice();
  }

  checkValue
  checkLength
  hideTable: boolean = false
  AddonsRemoval
  addonQuanityLength

  removeFromCart(dishId, index) {
    // let ords_add = JSON.parse(sessionStorage.getItem('addon-orders'));
    // this.totalcartvalue -= 1;
    // for (let ord of this.orders) {
    //   if (ord.food_dish_id == dishId) {
    //     ord.quantity -= 1
    //     if (ord.rdaoop_id) {
    //       let ords_add = JSON.parse(sessionStorage.getItem('addon-orders'));
    //       this.AddonsRemoval = ords_add;
    //       this.addonQuanityLength = ord.rdaoop_id.map(element => {
    //         return element.addonQuantity -= 1
    //       });
    //       ord.rdaoop_id.forEach((item: any) => {
    //         let index = ord.rdaoop_id.findIndex(element => element.addonQuantity == 0)
    //         if (index != -1) {
    //           ord.rdaoop_id.splice(index, 1);
    //         }
    //       })
    //     }
    //     ord.Price = parseInt(ord.Price) - parseInt(ord.originalPrice);
    //   }
    // }
    // this.orders.filter((v, i) => {
    //   if (v.quantity == 0) {
    //     this.orders.splice(i, 1);
    //     this.orderItem.splice(i, 1);
    //   }
    // })
    // sessionStorage.setItem("orders-data", JSON.stringify(this.orders));
    // sessionStorage.setItem("addon-orders", JSON.stringify(this.orders));
    // this.checkValue = sessionStorage.getItem("orders-data")
    // this.lengths = JSON.parse(this.checkValue)
    // this.checkLength = this.lengths.map((item: any) => {
    //   return item.indexVal
    // })
    // if (this.checkLength.length != 0) {
    //   this.hideTable = false;
    // } else if (this.checkLength.length == 0) {
    //   this.hideTable = true;
    // }
    // this.showmenuOrderget();
    // this.getTotalPrice();




    let local = JSON.parse(sessionStorage.getItem('orders-data'))
    if (local[index]['rdaoop_id']) {
      local.splice(index, 1)
    } else {
      local[index].quantity -= 1
      if (local[index].quantity == 0) {
        local.splice(index, 1)
      }
    }
    if (local.length == 0) {
      this.hideTable = true
      console.log('works')
    }
    sessionStorage.setItem('orders-data', JSON.stringify(local))
    this.showmenuOrderget();
    this.getTotalPrice();
  }

  totalPriceCalc
  totalPriceAfterAddition
  totalPriceAddon
  totalPriceMoney
  addonCalculatedPriceS
  datas = []
  dishesArray = []
  orderItemss = []

  getTotalPrice() {
    this.totalPriceAddon = 0
    let datas = []
    this.dishesAlldata = sessionStorage.getItem('orders-data');
    this.dishes = JSON.parse(this.dishesAlldata);
    if (this.dishes?.length) {
      this.totalPriceCalc = this.dishes.map((item: any) => {
        return (item.quantity * item.originalPrice)
      })
      console.log(this.dishes, '<<<---------')
      for (let ords of this.dishes) {
        if (ords.rdaoop_id) {
          if (ords.rdaoop_id.length > 0) {
            this.addonCalculatedPriceS = ords.rdaoop_id.map((element: any) => {
              return (element.addonPrice * element.addonQuantity)

            });
            this.totalPriceAddon += this.addonCalculatedPriceS?.reduce((a, b) => a + b, 0);
          }
        }
      }
      this.totalPriceMoney = this.totalPriceCalc.reduce((a, b) => a + b, 0)
      this.totalPriceAfterAddition = this.totalPriceMoney + (this.totalPriceAddon ? this.totalPriceAddon : 0);
    }
    for (let i = 0; i < this.dishes?.length; i++) {
      let temp1 =
      {
        dishId: this.dishes[i]?.food_dish_id,
        quantity: this.dishes[i]?.quantity,
        price: this.dishes[i]?.originalPrice,
      }
      this.orderItemss.push(temp1);
      let dasd = this.orderItemss.forEach((ite: any) => {
        if (ite.dishId == this.dishes[i]?.food_dish_id) {
          ite.quantity = ite.quantity + 1;
          return ite.quantity
        }
      })
      let index = this.orderItemss.findIndex((item: any) => item.dishId == this.dishes[i].food_dish_id)
    }
  }

  OrderPlaced: boolean = false;

  placeOrderObj
  placeOrder() {
    this.getTotalPrice()
    let orders_dara = sessionStorage.getItem("orders-data");
    let parseOrders = JSON.parse(orders_dara);

    for (let ords of parseOrders) {
      this.placeOrderObj = parseOrders.map(o => (
        {
          dishId: o.food_dish_id,
          quantity: o.quantity,
          price: o.originalPrice,
          option_id: o.option_id,
          epos_product_id: o.epos_product_id,
          restaurant_dish_addon_optionId: o.rdaoop_id?.map((item: any) => {
            return item.restaurant_dish_addon_optionId
          })
        }
      ));
    }
    let placeOrderObj = {
      restaurantId: this.restoID,
      tableId: this.tableID,
      orderDishes: this.placeOrderObj,
    }
    this.httpSv.placeOrder(placeOrderObj).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        sessionStorage.removeItem("orders-data");
        sessionStorage.removeItem("addon-orders")
        sessionStorage.removeItem("FinalArray");
        sessionStorage.removeItem("count");
        this.orderId = res['result'].data.order_no
        this.orderstatus = res['result'].data.order_status
        this.getDishOrderDetails();
        this.OrderPlaced = true;
        let data = {
          orderId: this.orderId,
          orderStatus: this.orderstatus
        }
        this.OrderPlaced = true;
        let sheetRef = this._bottomSheet.open(BottomSheetOverviewExampleSheets, {
          data: data,
        });
      }
      else {
        this.OrderPlaced = false;
      }
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  OrderDetails: any[] = [];
  orderDetailsorderId
  getDishOrderDetails() {
    this.httpSv.getOrderDetails(this.orderId).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.OrderDetails = res['result'].data.order_dishes;
        this.orderDetailsorderId = res['result'].data.order_id;
      }
    }, (err: any) => {
      console.log(err);
    })
  }
  rdaoopArray = []
  showmenuOrderget() {
    this.orderItem = [];
    this.dishesAlldata = sessionStorage.getItem('orders-data');
    this.dishes = JSON.parse(this.dishesAlldata);
    for (let i = 0; i < this.dishes.length; i++) {
      let temp =
      {
        food_dish_id: this.dishes[i].food_dish_id,
        quantity: this.dishes[i].quantity,
        price: this.dishes[i].Price,
        Name: this.dishes[i].Name,
        originalPrice: this.dishes[i].originalPrice,
        option_name: this.dishes[i].option_name,
        option_price: this.dishes[i].option_price,
        rdaoop: this.dishes[i].rdaoop_id
      }
      this.orderItem.push(temp);
      console.log(this.orderItem)
    }
  }



  closeModal() {
    this.modal.close();
  }

  amount_foodbud
  value_coupon(val) {
    this.amount_foodbud = val
    // console.log(parseFloat(val).toFixed(2),val);

    return parseFloat(val).toFixed(2);
  }



  ///////////  paymentgateway for Guest///////////////////////
  // openModalsView() {
  //   this.show_guest_modal = true
  //   let data = {
  //     showdiv:this.show_guest_modal
  //   }
  //   let sheetRef = this._bottomSheet.open(BottomSheetOverviewExampleSheets, {
  //     disableClose: true,
  //     data: data
  //   });
  // }

  // stripePaymentGateway() {
  //   if(!window.document.getElementById('stripe-script')) {
  //     const scr = window.document.createElement("script");
  //     scr.id = "stripe-script";
  //     scr.type = "text/javascript";
  //     scr.src = "https://checkout.stripe.com/checkout.js";
  //     scr.onload = () => {
  //       this.strikeCheckout = (<any>window).StripeCheckout.configure({
  //         key:environment.paymentgateway_Key,
  //         locale: 'auto',
  //         token: function (token: any) {
  //           sessionStorage.removeItem('Guest_name');

  //           alert('Payment via stripe successfull!');
  //         }
  //       });
  //     }  
  //     window.document.body.appendChild(scr);
  //   }
  // }
  // payment ='cod'
  // pay(e){
  //   this.payment = e
  // }
  // guest_paymeny(){
  //   const strikeCheckout = (<any>window).StripeCheckout.configure({
  //     key: environment.paymentgateway_Key,
  //     locale: 'auto',
  //     token: function (stripeToken: any) {
  //       console.log(stripeToken)
  //       alert('Stripe token generated!');

  //     }
  //   });

  //   strikeCheckout.open({
  //     name: 'Foodbud', 
  //     description: 'Payments',
  //     amount:this.amount_foodbud*100
  //   });
  // }

  value_add(value) {
    return value
  }
  total: number = 0;
  add: any;
  loadcart() {
    console.log("yes")
    if (sessionStorage.getItem("add")) {
      this.add = JSON.parse(sessionStorage.getItem("add"));
      console.log(this.add)

      console.log(this.total)
    }

  }




  increment(items) {

    console.log(items)
    if (items.Counter != 6) {
      items.Counter++;

      sessionStorage.setItem("add", JSON.stringify(items))
    }
  }
  decrement(items) {

    console.log(items)
    if (items.Counter != 1) {
      items.Counter--;
      sessionStorage.setItem("add", JSON.stringify(items))
    }

  }
  ngAfterViewInit() {

  }

  onChange({ error }) {
    this.error = error ? error.message : null;
    this.ref.detectChanges();
  }
  // ngAfterViewInit() {
  //   this.stripeService
  //     .setPublishableKey(environment.paymentgateway_Key)
  //     .then(stripe => {
  //       this.stripe = stripe;
  //       const elements = stripe.elements();
  //       this.card = elements.create("card",{hidePostalCode: true});
  //       setTimeout(() => {
  //         this.card.mount(this.cardInfo.nativeElement);
  //       }, 1000);
  //       // this.card.mount(this.cardInfo.nativeElement);
  //       this.card.addEventListener("change", this.cardHandler);
  //     });
  // }

  // handleChange(value) {
  //   // this.optionsvalue = value
  //   this.ngAfterViewInit();
  // }
  // async onSubmit(form: NgForm) {
  //   const { token, error } = await this.stripe.createToken(this.card);
  //   if (error) {
  //     console.log("Error:", error);
  //   } else {
  //     console.log("Success!", token.id);
  //     // console.log(this.card.id);
  //     this.modal.close();
  //   }

  // }

  showStripeCards: boolean = false;
  gotoPayments() {
    this.showBtnForCashPayment = false;
    this.showStripeCards = true;
    this.ngAfterViewInit();
    let data = {
      totalPay_amount: this.totalPriceAfterAddition

    }
    let paymentSheet = this._bottomSheet.open(BottomSheetPayments, {
      data: data
    });

    paymentSheet.afterDismissed().subscribe((dataFromChild) => {
      if (dataFromChild) {
        let sheetRef = this._bottomSheet.open(BottomSheetOverviewExampleSheets, {
          data: data,
        });
        this.OrderPlaced = true;
        this.OrderDetails = dataFromChild.orderDetails
        this.orderDetailsorderId = dataFromChild.orderDetailsorderId;
      }
    })
  }

  showPaymentOptions: boolean = false;
  checkPaymentOptions() {
    this.showPaymentOptions = true;
    this.showBtnForCashPayment = false;
  }

  gotoYottaPay() {
    this.showBtnForCashPayment = false;
    this.showStripeCards = false;
    let data = {
      totalPay_amount: this.totalPriceAfterAddition

    }
    // "payment_source":"yottaPay",
    let orders_dara = sessionStorage.getItem("orders-data");
    let parseOrders = JSON.parse(orders_dara);
    for (let ords of parseOrders) {
      this.placeOrderObj = parseOrders.map(o => (
        {
          dishId: o.food_dish_id,
          quantity: o.quantity,
          price: o.originalPrice,
          option_id: o.option_id,
          restaurant_dish_addon_optionId: o.rdaoop_id?.map((item: any) => {
            return item.restaurant_dish_addon_optionId
          })
        }
      ));
    }
    let placeOrderWithPaymentObj = {
      restaurantId: this.restoID,
      tableId: this.tableID,
      totalPay_amount: this.totalPriceAfterAddition,
      orderDishes: this.placeOrderObj,
      payment_source: "yottaPay",
    }

    this.httpSv.placeOrderWithPayment(placeOrderWithPaymentObj).subscribe((res: any) => {
      console.log(res)
      if (res['status'] == "TRUE") {
        console.log("yotta response", res['result'].data.yottapayDtl.url_process_payment_intent)
        window.location.href = res['result'].data.yottapayDtl.url_process_payment_intent;
        // window.open(res['result'].data.yottapayDtl.url_process_payment_intent);
        // window.open(res['result'].data.yottapayDtl.url_process_payment_intent, "_blank");
        // sessionStorage.removeItem("orders-data");
        // sessionStorage.removeItem("addon-orders")
        // sessionStorage.removeItem("FinalArray");
        // sessionStorage.removeItem("count");
        // this.orderId = res['result'].data.order_no
        // this.orderstatus = res['result'].data.order_status
        // this.getDishOrderDetails();
        // this.OrderPlaced = true;
      }
    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
    console.log(this.placeOrderObj)


  }
  showBtnForCashPayment: boolean = false;
  goToPlaceOrders() {
    this.showBtnForCashPayment = true;
    this.showPaymentOptions = false;
  }

  getLoginScreen() {
    if (this.UserCondition) {
      this.UserCondition = true;
      this.router.navigate(['/horizontal/food-menu'])
    } else {
      let sheetRef = this._bottomSheet.open(BottomSheetGuestLogin, {
        disableClose: true
      });
      sheetRef.afterDismissed().subscribe((dataFromChild) => {
        if (dataFromChild) {
          this.ngOnInit();
        }
      });
    }
  }

  testFunc(val, items) {
    console.log(val)
    console.log(items)
  }



}

@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'bottom-sheet-overview-example-sheet.html',

})

export class BottomSheetOverviewExampleSheets implements OnInit {

  OrderId
  orderstatus
  UserCondition
  dishes
  selectedAlleregence
  show_guest_modal
  name
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private router: Router, private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheets>, private modal: TCModalService,
    private _bottomSheet: MatBottomSheet) {
    this.data = data
  }
  ngOnInit() {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    this.OrderId = this.data.orderId
    this.orderstatus = this.data.orderStatus

    setTimeout(() => {
      this.bottomSheetRef.dismiss();
    }, 2000);
  }


  onPlaceorder_user() {
    this.bottomSheetRef.dismiss();
  }
  onPlaceorder_guest() {
    this.bottomSheetRef.dismiss();
  }

  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  //////////////////paymentgate-way///////////////////////////
  // payment_okguest(){
  //  sessionStorage.setItem('Guest_name',this.name)
  //  if(this.name){
  //   this.onPlaceorder_guest();
  // location.reload();
  //  }

  // }
}

@Component({
  selector: 'bottom-sheet-guest-login',
  templateUrl: 'bottom-sheet-guest-login.html',
})
export class BottomSheetGuestLogin implements OnInit {
  cookie: string = 'NotAccepted'
  showmore: boolean = false
  clickinfo: boolean = true
  showVerifyOtp: boolean = false;
  getOtpForm: FormGroup;
  getnameForm: FormGroup
  expirationInMin
  email
  showEmail: boolean = true;
  otpResponse: any;
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<BottomSheetGuestLogin>, private router: Router, public httpSv: HttpService, private changeDetectorRef: ChangeDetectorRef,) {
  }

  ngOnInit() {
    this.otpForm();
    this.UserNameForm();
  }

  otpForm() {
    this.getOtpForm = new FormGroup({
      userEmail: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]),
    })
  }

  UserNameForm() {
    this.getnameForm = new FormGroup({
      userName: new FormControl('', [Validators.required])
    })
  }

  Privacy() {
    this.closeModal();
    this.router.navigate(['/public/privacy'])
  }
  terms() {
    this.closeModal();
    this.router.navigate(['/public/terms'])
  }
  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  userEmailStored
  is_new_user;
  submitted: boolean = false;
  sendOtpByEmail() {
    this.submitted = true;
    if (this.getOtpForm.valid) {
      this.showEmail = !this.showEmail
      sessionStorage.removeItem("access_token");
      this.userEmailStored = this.getOtpForm.value.userEmail;
      this.httpSv.sendOtpByEmail(this.getOtpForm.value.userEmail).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          const b64 = res.result.data; // base64 string
          const decodedStr = atob(b64); // -> JSON string (if it was encoded as plain ASCII/UTF-8)
          const decodedObj = JSON.parse(decodedStr);

          // this.otpData = decodedObj.otp;
          this.otpResponse = decodedObj.otp;
          this.is_new_user = decodedObj.is_new_user;
        }
        else {

        }
      })
    } else {

    }

  }
  get_OTP(value) {
  }

  authToken
  hideVerifyOTP: boolean = false
  showErrorMessage: boolean = false
  verifyOtp(e) {
    if ((this.is_new_user == "True")) {
      if (this.otpResponse == parseInt(this.otpValue)) {
        this.hideVerifyOTP = true
      }
      else {
        this.showErrorMessage = true;
      }
    } else {
      if (this.otpResponse == parseInt(this.otpValue)) {
        let otpObj = {
          email: this.getOtpForm.value.userEmail,
          otp: this.otpValue,
        }
        this.httpSv.verifyOTPUser(otpObj).subscribe((res: any) => {
          if (res['status'] == "TRUE") {
            this.closeModal();
            if (this.is_new_user == "True") {
              this.hideVerifyOTP = true
            }
            this.authToken = res.result.token;
            this.setUserName(res.result);
            sessionStorage.setItem('access_token', this.authToken);
            // this.router.navigate(['/public/order-menu-guest'])
            this.bottomSheetRef.dismiss();
          }
          else {
          }
        })
      } else {
        this.showErrorMessage = true;
      }
    }
  }


  otpValue
  onOtpChange(e) {
    if (e.length == 4) {
      this.otpValue = e;
      this.verifyOtp(e);
    }
  }

  resendOtp() {
    this.showEmail = !this.showEmail
    this.sendOtpByEmail();
  }

  UserCondition: boolean = false;
  getUsernameAndOtp() {
    let otpObj = {
      email: this.getOtpForm.value.userEmail,
      otp: this.otpValue,
      name: this.getnameForm.value.userName
    }
    this.httpSv.verifyOTPUser(otpObj).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.closeModal();
        this.authToken = res.result.token;
        this.setUserName(res.result);
        sessionStorage.setItem('access_token', this.authToken);
        this.bottomSheetRef.dismiss();
        this.UserCondition = true
      }
      else {
      }
    })
  }

  userNames
  userEmails
  userEmailSplitted
  setUserName(data) {
    this.userNames = data.userDetails.name;
    this.userEmails = data.userDetails.email;
    // this.userEmailSplitted = this.userEmails.substr(0, this.userEmails.indexOf('@'));
    sessionStorage.setItem("userName", this.userNames)
    sessionStorage.setItem("email", this.userEmails);

  }
  get f() {
    return this.getOtpForm.controls;
  }

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

@Component({
  selector: 'bottom-sheet-dish-addon',
  templateUrl: 'bottom-sheet-dish-addon.html',
})

export class BottomSheetDishAddon implements OnInit {
  ApiData
  foodName
  options = []
  defaultSelected = 0
  addonList = []
  addonListShow: boolean = false;
  checknox_id
  select_value_rdoop = []
  dishAddonArray: any[] = [];
  restoID
  select_value = []
  selectedOptId
  totalDishPriceAfterAddons
  token
  first_price
  optName

  constructor(
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetGuestLogin>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router
  ) {

  }
  ngOnInit() {
    this.ApiData = this.data;
    this.options = this.ApiData.addonArray.dish_options;
    this.defaultSelected = 0;
    this.foodName = this.ApiData.addonArray.name;
    this.addonList = this.ApiData.addonArray.dish_addons;
    if (this.addonList) {
      this.addonListShow = true;
    } else {
      this.addonListShow = false;
    }
    this.restoID = sessionStorage.getItem('restoId');
    this.token = sessionStorage.getItem('access_token');
    this.first_price = this.options[0].option_price;
    this.option_ID = this.options[0].option_id;
    this.optName = this.options[0].option_name;
    this.sendAddondetails(this.option_ID, this.optName, this.first_price, 0)
  }

  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto']);
        }
        else {
          Swal.fire("Something Went Wrong")
        }
      }
    )
  }
  addOnObjs
  adddonObj
  disableAddBtn: boolean = true;
  optionPriceBasedOnQuantity
  // select_addons(id, rdip, addonName, addonprice, e) {
  //   this.checknox_id = id
  //   if (e.checked) {
  //     this.select_value.push(id)
  //     if (this.select_value.length > 0) {
  //       this.disableAddBtn = false;
  //     }
  //     this.adddonObj = {
  //       addonId: id,
  //       addonName: addonName,
  //       addonPrice: addonprice,
  //       addonQuantity: 1,
  //       restaurant_dish_addon_optionId: rdip
  //     }
  //     this.addOnObjs = this.adddonObj;
  //     this.select_value_rdoop.push(this.addOnObjs);
  //     this.dishAddonArray = this.select_value;
  //     let addonObj = {
  //       restaurant_id: this.restoID,
  //       dish_id: this.ApiData.food_dish_id,
  //       quantity: 1,
  //       option_id: this.selectedOptId,
  //       dish_addon_id: this.dishAddonArray
  //     }
  //     let ords = JSON.parse(sessionStorage.getItem('orders-data'));
  //     if (ords && ords.length) {
  //       this.orders = ords;
  //     }
  //     for (let i = 0; i < this.orders.length; i++) {
  //       if (this.orders[i].food_dish_id == this.ApiData.food_dish_id) {
  //         this.orders[i].rdaoop_id.push(this.addOnObjs)
  //         sessionStorage.setItem('addon-orders', JSON.stringify(this.orders))
  //         sessionStorage.setItem('orders-data', JSON.stringify(this.orders))
  //       }
  //     }
  //     this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
  //       if (res['status'] == "TRUE") {
  //         this.totalDishPriceAfterAddons = res.result.totalDishPrice;
  //         this.changeDetectorRef.detectChanges();
  //       }
  //     }, (err: any) => {
  //       if (err.status == 401 || err.status == 500) {
  //         this.logout();
  //       }
  //     })
  //   }
  //   else {
  //     if (this.select_value.length == 0) {
  //       this.disableAddBtn = true;
  //     }
  //     let ords = JSON.parse(sessionStorage.getItem('orders-data'));
  //     if (ords && ords.length) {
  //       this.orders = ords;
  //     }
  //     let index = this.select_value.findIndex(ele => ele == id)

  //     for (let i = 0; i < this.orders.length; i++) {
  //       if (this.orders[i].food_dish_id == this.ApiData.food_dish_id) {
  //         let lastIndexed = this.orders[i].rdaoop_id.map((item: any) => {
  //           return item.addonId;
  //         })
  //         let idgsd = this.orders[i].rdaoop_id.forEach(element => {
  //           return element.addonId
  //         })
  //         let removalid = lastIndexed.lastIndexOf(id);
  //         this.orders[i].rdaoop_id.splice(removalid, 1)
  //         sessionStorage.setItem('addon-orders', JSON.stringify(this.orders))
  //         sessionStorage.setItem('orders-data', JSON.stringify(this.orders))
  //       }
  //     }

  //     this.select_value.splice(index, 1)
  //     this.dishAddonArray = this.select_value;
  //     let addonObj = {
  //       restaurant_id: this.restoID,
  //       dish_id: this.ApiData.food_dish_id,
  //       quantity: 1,
  //       option_id: this.selectedOptId,
  //       dish_addon_id: this.dishAddonArray
  //     }

  //     this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
  //       if (res['status'] == "TRUE") {
  //         this.totalDishPriceAfterAddons = res.result.totalDishPrice;
  //         this.changeDetectorRef.detectChanges();
  //       }
  //     }, (err: any) => {
  //       if (err.status == 401 || err.status == 500) {
  //         this.logout();
  //       }
  //     })
  //   }
  // }
  select_addons(id, rdip, addonName, addonprice, e) {
    this.checknox_id = id
    if (e.checked) {
      this.select_value.push(id)
      if (this.select_value.length > 0) {
        this.disableAddBtn = false;
      }
      let adddonObj = {
        addonId: id,
        addonName: addonName,
        addonPrice: addonprice,
        addonQuantity: 1,
        restaurant_dish_addon_optionId: rdip
      }
      this.select_value_rdoop.push(adddonObj);
      this.dishAddonArray = this.select_value;
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: this.selectedOptId,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.totalDishPriceAfterAddons = res.result.totalDishPrice;
          this.optionPriceBasedOnQuantity = res.result.optionPriceBasedOnQuantity;
          this.changeDetectorRef.detectChanges();
        }
      }, (err: any) => {
        console.log(err)
      })
    }
    else {
      let index = this.select_value.findIndex(ele => ele == id)
      this.select_value.splice(index, 1)
      if (this.select_value.length == 0) {
        this.disableAddBtn = true;
      }
      this.dishAddonArray = this.select_value;
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: this.selectedOptId,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.totalDishPriceAfterAddons = res.result.totalDishPrice;
          this.changeDetectorRef.detectChanges();
        }
      }, (err: any) => {
        console.log(err)
      })
    }
  }

  sub
  cartLength
  length
  counts
  lengths
  orders = []
  option_ID
  quantity = 1
  totalcartvalues
  rdaoopArray
  pushingObjs
  accArray = []
  accArrays = []
  // dataPass() {
  //   let ords = JSON.parse(sessionStorage.getItem('orders-data'));
  //   if (ords && ords.length) {
  //     this.orders = ords;
  //   }
  //   let value = this.orders[this.ApiData.index];
  //   this.accArray = []
  //   this.accArray.push(value);


  //   // let ords = JSON.parse(sessionStorage.getItem('orders-data'));
  //   // if (ords && ords.length) {
  //   //   this.orders = ords;
  //   // }
  //   if (this.accArray == null) {
  //     this.accArray.push({
  //       "food_dish_id": this.ApiData.food_dish_id, "quantity": this.quantity, "Name": this.foodName, "Price": this.totalDishPriceAfterAddons, "originalPrice": this.totalDishPriceAfterAddons,
  //       "option_id": this.option_ID, "option_name": this.option_names, "option_price": this.option_prices, "rdaoop_id": this.select_value_rdoop,
  //     })
  //     sessionStorage.setItem('orders-data', JSON.stringify(this.accArray));
  //     sessionStorage.setItem('addon-orders', JSON.stringify(this.accArray))
  //     this.closeModal();
  //   }
  //   else {
  //     this.totalcartvalues += 1;
  //     let count = 1
  //     let push = true
  //     let ordsgt = JSON.parse(sessionStorage.getItem('orders-data'));
  //     if (ordsgt && ordsgt.length) {
  //       this.orders = ordsgt;
  //     }
  //     let value = this.orders[this.ApiData.index];
  //     this.accArrays = []
  //     this.accArrays.push(value);
  //     for (let ordsgt of this.accArrays) {
  //       if (ordsgt.food_dish_id == this.ApiData.food_dish_id) {
  //         push = false
  //       }
  //     }
  //     if (push) {
  //       this.accArray.push({ "rdaoop_id": this.select_value_rdoop })
  //       sessionStorage.setItem('addon-orders', JSON.stringify(this.accArray))
  //       sessionStorage.setItem('orders-data', JSON.stringify(this.accArray));
  //     }
  //     else {
  //     }
  //     this.closeModal();
  //   }

  //   let data = {
  //     lengths: this.lengths,
  //     food_dish_id: this.ApiData.food_dish_id,
  //     price: this.select_value_rdoop,
  //     index: this.ApiData.index
  //   }
  //   this.bottomSheetRef.dismiss(data);
  // }
  testTemp
  dataPass() {
    let temp = {
      "food_dish_id": this.ApiData.food_dish_id,
      "quantity": this.quantity,
      "Name": this.foodName,
      "Price": this.totalDishPriceAfterAddons,
      "originalPrice": this.optionPriceBasedOnQuantity,
      "option_id": this.option_ID,
      "option_name": this.option_names,
      "option_price": this.option_prices,
      "rdaoop_id": this.select_value_rdoop
    }
    let local = JSON.parse(sessionStorage.getItem('orders-data'))
    local.push(temp)
    sessionStorage.setItem('orders-data', JSON.stringify(local))
    this.bottomSheetRef.dismiss()
  }

  option_names
  option_prices
  indexValueAddon
  showSomeData: boolean = false
  showAddonData: boolean = false;
  addonBasedonOptionId = []
  sendAddondetails(optionIds, optionsName, optionsPrice, index) {
    if (this.dishAddonArray.length != 0) {
      this.dishAddonArray.splice(0, this.dishAddonArray.length)
    }
    if (this.select_value_rdoop.length > 0) {
      this.select_value_rdoop.splice(0, this.select_value_rdoop.length)
    }
    this.option_ID = optionIds;
    this.option_names = optionsName;
    this.option_prices = optionsPrice;
    this.indexValueAddon = index
    this.selectedOptId = optionIds
    let addonObj = {
      restaurant_id: this.restoID,
      dish_id: this.ApiData.food_dish_id,
      quantity: 1,
      option_id: optionIds,
      dish_addon_id: this.dishAddonArray
    }
    this.testTemp = addonObj
    this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
      this.totalDishPriceAfterAddons = res.result.totalDishPrice;
      this.addonBasedonOptionId = res.result.addonBasedonOptionId;
      if (this.addonBasedonOptionId) {
        this.showAddonData = true;
        this.addonListShow = false;
      } else {
        this.addonListShow = false;
        this.showAddonData = true;
      }
      this.changeDetectorRef.detectChanges();

    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  value_coupon(val) {
    return parseFloat(val).toFixed(2);
  }
  valueAddonMoney(val) {
    return parseFloat(val).toFixed(1);
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

@Component({
  selector: 'bottom-sheet-payments',
  templateUrl: 'bottom-sheet-payments.html',

})

export class BottomSheetPayments implements OnInit {

  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  // @ViewChild('cardExpiry', { static: false }) cardExpiry: ElementRef;
  // @ViewChild('cardCvv', { static: false }) cardCvv: ElementRef;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetPayments>,
    private _bottomSheet: MatBottomSheet,
    private stripeService: AngularStripeService,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.data = data
  }
  placeOrderObj
  totalPayMoney
  token
  ngOnInit() {
    this.totalPayMoney = this.data.totalPay_amount
    this.restoID = sessionStorage.getItem("restoId");
    this.tableID = sessionStorage.getItem('tableId');
    this.token = sessionStorage.getItem('access_token')
    let orders_dara = sessionStorage.getItem("orders-data");
    let parseOrders = JSON.parse(orders_dara);
    for (let ords of parseOrders) {
      this.placeOrderObj = parseOrders.map(o => (
        {
          dishId: o.food_dish_id,
          quantity: o.quantity,
          price: o.originalPrice,
          option_id: o.option_id,
          restaurant_dish_addon_optionId: o.rdaoop_id?.map((item: any) => {
            return item.restaurant_dish_addon_optionId
          })
        }
      ));
    }
    this.ngAfterViewInit();
  }

  restoID
  OrderPlaced: boolean = false;
  tableID
  orderId
  orderstatus
  generatedStripeToken
  async onSubmit(form: NgForm) {
    let { token, error } = await this.stripe.createToken(this.card);
    if (error) {
      console.log("Error:", error);
    } else {
      console.log("Success!", token.id);
      this.generatedStripeToken = token.id;
      let placeOrderWithPaymentObj = {
        restaurantId: this.restoID,
        tableId: this.tableID,
        totalPay_amount: this.totalPayMoney,
        stripeToken: this.generatedStripeToken,
        orderDishes: this.placeOrderObj
      }
      this.httpSv.placeOrderWithPayment(placeOrderWithPaymentObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          sessionStorage.removeItem("orders-data");
          sessionStorage.removeItem("addon-orders")
          sessionStorage.removeItem("FinalArray");
          sessionStorage.removeItem("count");
          this.orderId = res['result'].data.order_no
          this.orderstatus = res['result'].data.order_status
          this.getDishOrderDetails();
          this.OrderPlaced = true;
        }
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    }

  }
  cardHandler = this.onChange.bind(this);
  card: any;
  paymentForm: FormGroup;
  stripeCardValid: boolean = false;
  stripe;
  error: string;
  cardExpiries: any;
  cardCvvs: any;

  onChange({ error }) {
    this.error = error ? error.message : null;
    this.ref.detectChanges();
  }
  ngAfterViewInit() {
    this.stripeService
      .setPublishableKey(environment.paymentgateway_Key)
      .then(stripe => {
        this.stripe = stripe;
        const elements = stripe.elements();
        this.card = elements.create("card", { hidePostalCode: true });

        // this.card = elements.create("cardNumber",{hidePostalCode: true});
        // this.cardExpiries = elements.create("cardExpiry");
        // this.cardCvvs = elements.create("cardCvc",{hidePostalCode: true});
        // setTimeout(() => {
        this.card.mount(this.cardInfo.nativeElement);
        // this.cardExpiries.mount(this.cardExpiry.nativeElement);
        // this.cardCvvs.mount(this.cardCvv.nativeElement);
        // }, 1000);
        // this.card.mount(this.cardInfo.nativeElement);
        this.card.addEventListener("change", this.cardHandler);
      });
  }

  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  strikeCheckout: any = null;
  stripePaymentGateway() {
    if (!window.document.getElementById('stripe-script')) {
      const scr = window.document.createElement("script");
      scr.id = "stripe-script";
      scr.type = "text/javascript";
      scr.src = "https://checkout.stripe.com/checkout.js";
      scr.onload = () => {
        this.strikeCheckout = (<any>window).StripeCheckout.configure({
          key: environment.paymentgateway_Key,
          locale: 'auto',
          token: function (token: any) {
            sessionStorage.removeItem('Guest_name');

            alert('Payment via stripe successfull!');
          }
        });
      }
      window.document.body.appendChild(scr);
    }
  }
  payment = 'cod'
  pay(e) {
    this.payment = e
  }
  guest_paymeny() {
    const strikeCheckout = (<any>window).StripeCheckout.configure({
      key: environment.paymentgateway_Key,
      locale: 'auto',
      token: function (stripeToken: any) {
        console.log(stripeToken)
        alert('Stripe token generated!');

      }
    });

    strikeCheckout.open({
      name: 'Foodbud',
      description: 'Payments',
      amount: 1 * 100
    });
  }

  placePaymentOrders() {

  }
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto']);
        }
        else {
          Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  OrderDetails
  orderDetailsorderId
  placedOrderDetails
  getDishOrderDetails() {
    this.httpSv.getOrderDetails(this.orderId).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.OrderDetails = res['result'].data.order_dishes;
        this.orderDetailsorderId = res['result'].data.order_id;
        this.placedOrderDetails = {
          orderDetails: this.OrderDetails,
          orderDetailsorderId: this.orderDetailsorderId
        }
        this.bottomSheetRef.dismiss(this.placedOrderDetails);
      }
    }, (err: any) => {
      console.log(err);
    })
  }
  //////////////////paymentgate-way///////////////////////////
  // payment_okguest(){
  //  sessionStorage.setItem('Guest_name',this.name)
  //  if(this.name){
  //   this.onPlaceorder_guest();
  // location.reload();
  //  }

  // }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}






@Component({
  selector: 'bottom-sheet-dish-edit-addon',
  templateUrl: './buttom-sheet-dish-edit-addon.html',
})

export class BottomSheetDishEditAddon implements OnInit {
  ApiData
  foodName
  options = []
  defaultSelected = 0
  addonList = []
  addonListShow: boolean = false;
  checknox_id
  select_value_rdoop = []
  dishAddonArray: any[] = [];
  restoID
  select_value = []
  selectedOptId
  totalDishPriceAfterAddons
  token
  first_price
  optName
  oneDishData
  variantReqIndex

  constructor(
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetGuestLogin>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router
  ) {

  }
  ngOnInit() {
    this.ApiData = this.data;
    this.variantReqIndex = this.ApiData.variantReqIndex
    this.options = this.ApiData.addonArray.dish_options;
    this.defaultSelected = 0;
    this.foodName = this.ApiData.addonArray.name;
    this.addonList = this.ApiData.addonArray.dish_addons;
    if (this.addonList) {
      this.addonListShow = true;
    } else {
      this.addonListShow = false;
    }
    this.restoID = sessionStorage.getItem('restoId');
    this.token = sessionStorage.getItem('access_token');
    this.oneDishData = JSON.parse(sessionStorage.getItem('orders-data'))[this.ApiData.index]
    this.first_price = this.options[this.variantReqIndex].option_price;
    this.option_ID = this.options[this.variantReqIndex].option_id;
    this.optName = this.options[this.variantReqIndex].option_name;
    this.sendAddondetails(this.option_ID, this.optName, this.first_price, this.variantReqIndex)
    this.preSelectedAddOn(this.oneDishData['rdaoop_id'])

  }

  closeModal() {
    this.bottomSheetRef.dismiss();
  }
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto']);
        }
        else {
          Swal.fire("Something Went Wrong")
        }
      }
    )
  }
  addOnObjs
  adddonObj
  disableAddBtn: boolean = true;
  optionPriceBasedOnQuantity
  select_addons(id, rdip, addonName, addonprice, e) {
    this.checknox_id = id
    if (e.checked) {
      this.select_value.push(id)
      if (this.select_value.length > 0) {
        this.disableAddBtn = false;
      }
      let adddonObj = {
        addonId: id,
        addonName: addonName,
        addonPrice: addonprice,
        addonQuantity: 1,
        restaurant_dish_addon_optionId: rdip
      }
      this.select_value_rdoop.push(adddonObj);
      this.dishAddonArray = this.select_value;
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: this.selectedOptId,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.totalDishPriceAfterAddons = res.result.totalDishPrice;
          this.optionPriceBasedOnQuantity = res.result.optionPriceBasedOnQuantity;
          this.changeDetectorRef.detectChanges();
        }
      }, (err: any) => {
        console.log(err)
      })
    }
    else {
      let index = this.select_value.findIndex(ele => ele == id)
      this.select_value.splice(index, 1)
      this.select_value_rdoop.splice(index, 1)
      if (this.select_value.length > 0) {
        this.disableAddBtn = false;
      } else this.disableAddBtn = true
      this.dishAddonArray = this.select_value;
      let addonObj = {
        restaurant_id: this.restoID,
        dish_id: this.ApiData.food_dish_id,
        quantity: 1,
        option_id: this.selectedOptId,
        dish_addon_id: this.dishAddonArray
      }
      this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.totalDishPriceAfterAddons = res.result.totalDishPrice;
          this.optionPriceBasedOnQuantity = res.result.optionPriceBasedOnQuantity;
          this.changeDetectorRef.detectChanges();
        }
      }, (err: any) => {
        console.log(err)
      })
    }
  }
  preSelectedAddOn(data) {
    for (let i = 0; i < data.length; i++) {
      this.dishAddonArray.push(data[i]['addonId'])
      this.select_value.push(data[i]['addonId'])
      this.select_value_rdoop.push(data[i])
    }
    let addonObj = {
      restaurant_id: this.restoID,
      dish_id: this.ApiData.food_dish_id,
      quantity: 1,
      option_id: this.selectedOptId,
      dish_addon_id: this.dishAddonArray
    }
    this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
      if (res['status'] == "TRUE") {
        this.totalDishPriceAfterAddons = res.result.totalDishPrice;
        this.changeDetectorRef.detectChanges();
      }
    }, (err: any) => {
      console.log(err)
    })

  }

  sub
  cartLength
  length
  counts
  lengths
  orders = []
  option_ID
  quantity = 1
  totalcartvalues
  rdaoopArray
  pushingObjs
  accArray = []
  accArrays = []

  testTemp
  dataPass() {
    let temp = {
      "food_dish_id": this.ApiData.food_dish_id,
      "quantity": this.quantity,
      "Name": this.foodName,
      "Price": this.totalDishPriceAfterAddons,
      "originalPrice": this.optionPriceBasedOnQuantity,
      "option_id": this.option_ID,
      "option_name": this.option_names,
      "option_price": this.option_prices,
      "rdaoop_id": this.select_value_rdoop
    }
    let local = JSON.parse(sessionStorage.getItem('orders-data'))
    local[this.ApiData.index] = temp
    sessionStorage.setItem('orders-data', JSON.stringify(local))
    this.bottomSheetRef.dismiss()
  }

  option_names
  option_prices
  indexValueAddon
  showSomeData: boolean = false
  showAddonData: boolean = false;
  addonBasedonOptionId = []
  sendAddondetails(optionIds, optionsName, optionsPrice, index) {
    this.option_ID = optionIds;
    this.option_names = optionsName;
    this.option_prices = optionsPrice;
    this.indexValueAddon = index
    this.selectedOptId = optionIds
    let addonObj = {
      restaurant_id: this.restoID,
      dish_id: this.ApiData.food_dish_id,
      quantity: 1,
      option_id: optionIds,
      dish_addon_id: this.dishAddonArray
    }
    this.testTemp = addonObj
    this.httpSv.postAddonDetails(addonObj).subscribe((res: any) => {
      this.totalDishPriceAfterAddons = res.result.totalDishPrice;
      this.addonBasedonOptionId = res.result.addonBasedonOptionId;
      if (this.addonBasedonOptionId) {
        this.showAddonData = true;
        this.addonListShow = false;
      } else {
        this.addonListShow = false;
        this.showAddonData = true;
      }
      this.changeDetectorRef.detectChanges();

    }, (err: any) => {
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  removeOldData() {
    if (this.dishAddonArray.length != 0) {
      this.dishAddonArray.splice(0, this.dishAddonArray.length)
    }
    if (this.select_value_rdoop.length > 0) {
      this.select_value_rdoop.splice(0, this.select_value_rdoop.length)
    }
    if (this.select_value.length != 0) {
      this.select_value.splice(0, this.select_value.length)
    }
    this.oneDishData = []
    if (this.select_value.length == 0)
      this.disableAddBtn = true;
  }

  value_coupon(val) {
    return parseFloat(val).toFixed(2);
  }
  valueAddonMoney(val) {
    return parseFloat(val).toFixed(1);
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
  variantCheckFunc(item, index) {
    if (this.oneDishData.length != 0) {
      if (item.option_name == this.oneDishData.option_name) {
        return true
      }
      else return false
    }
    else return false
  }
  btnCount = 0
  addOnCheckFunc(item) {
    if (this.oneDishData.length != 0) {
      let temp = this.oneDishData['rdaoop_id'].filter(ele => ele.addonId == item.dish_addon_id)
      if (temp.length != 0) {
        if (this.btnCount == 0) {
          this.disableAddBtn = false;
          this.btnCount += 1
        }
        return true
      }
      else return false
    }
    else return false
  }
}